import { AxiosResponse } from 'axios';
import { ApiService } from '../api/axios';

export class CheckIntegrationService {
	async fetchIDAustriaLogin(): Promise<AxiosResponse> {
		const res = await ApiService.post('/ida/login');
		window.location.href = res.data.redirectURL;
		return res;
	}

	async createPosIdentSession(): Promise<AxiosResponse> {
		return await ApiService.post('/pos-ident/session');
	}

	async checkPosIdentStatus(): Promise<AxiosResponse> {
		return await ApiService.post('/pos-ident/status');
	}

	async markPosIdentRedirection(): Promise<AxiosResponse> {
		return await ApiService.post('/pos-ident/mark-redirection');
	}
}

export const checkIntegrationService = new CheckIntegrationService();
